import script from "./NoPermission.vue?vue&type=script&setup=true&lang=js"
export * from "./NoPermission.vue?vue&type=script&setup=true&lang=js"

import "./NoPermission.vue?vue&type=style&index=0&id=47ec4f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ec4f60"]])

export default __exports__